import { createHttpService } from '../ApiService';
import {
  UsersByCategoryParams,
  TUsersByCategoryResponse,
} from './users.interfaces';

export const useUsersAdminService = () => {
  const httpAPI = createHttpService();
  const shouldUseMock = import.meta.env.VITE_APP_WITH_MOCK_DATA === 'true';

  const getUsersByCategory = (
    params: UsersByCategoryParams,
  ): Promise<TUsersByCategoryResponse> => {
    if (shouldUseMock) {
      return Promise.resolve({ data: [], count: 0, page: params.page ?? 1, limit: params.limit ?? 10 });
    }
    return httpAPI.users.get<TUsersByCategoryResponse>('/by-category', {
      params: {
        category: params.category,
        page: params.page ?? 1,
        limit: params.limit ?? 10,
        ...(params.search ? { search: params.search } : {}),
      },
    });
  };

  return { getUsersByCategory };
};
